import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux'

import { Modal, Button } from 'components';
import InnovationAnimate from 'resources/innovation-animate.svg'
import * as actionCreators from 'store/actions';

const Container = styled.div`
    background-color: var(--focus-color);
    padding: 2rem;
    box-shadow: var(--box-shadow);
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    justify-content: center;
    align-items: stretch;
    max-width: 20rem;
    width: 80vw;
    color: #fff;
`

const Title = styled.div`
    font-weight: bold;
    text-align: center;
`

const Text = styled.span`
    font-size: 0.9rem;
    text-align: justify;
    margin-top: 0.5rem;
`

const Image = styled.img`
    width: 100%;
    max-width: 25rem;
`

const buttonStyle = {
    backgroundColor: 'var(--secondary-color)',
    text: 'white',
    margin: '0.5rem 0 0 0'
}

const BetaModal = props => {
    const {} = props;
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user)

    const onClose = () =>  {
        let updatedUser = {...user}
        dispatch(actionCreators.setModal(null,null))
        if(updatedUser['show_loginModal']){
            updatedUser['show_loginModal'] = false
            dispatch(actionCreators.updateUser(updatedUser))
        }
    }

    return (
        <Modal onClose={onClose}>
            <Container>
                <Title>Thanks for joining Atomicly early!</Title>
                <Image src={InnovationAnimate}/> 
                <Text>We're currently in beta, which means everything is free! If you have any feedback, we would love to hear from you.</Text>
                <Text>Contact us at team@atomicly.io or fill up the feedback form available in the toolbar</Text>
                <Button text='Close' styles={buttonStyle} onSelect={onClose}/>
            </Container>
        </Modal>
    )
}

export default BetaModal